(() => {
  if (window.echoesMarketInitialized) return;
  window.echoesMarketInitialized = true;
  const compact = matchMedia('(max-width:749px), (max-width:1150px) and (max-height:500px)');
  const initialize = root => root.querySelectorAll('[data-header-market]').forEach(market => {
    if (market.hasAttribute('data-market-ready')) return;
    market.setAttribute('data-market-ready', '');
    const panel = market.querySelector('.header-market-panel');
    const trigger = market.querySelector('summary');
    panel.setAttribute('role', 'dialog');
    trigger.setAttribute('aria-expanded', String(market.open));
    const close = (restore = false) => {
      market.open = false;
      if (restore) trigger.focus({ preventScroll: true });
    };
    market.querySelectorAll('[data-market-dismiss]').forEach(button => button.addEventListener('click', () => close(true)));
    market.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', String(market.open));
      document.body.classList.toggle('market-panel-open', !!document.querySelector('[data-header-market][open]'));
      panel.setAttribute('aria-modal', String(compact.matches));
      if (market.open) {
        const selected = market.querySelector('input:checked');
        selected?.scrollIntoView({ block: 'nearest' });
        if (compact.matches) panel.focus({ preventScroll: true });
      }
    });
    market.addEventListener('keydown', event => {
      if (!market.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        close(true);
      }
      if (event.key === 'Tab' && compact.matches) {
        const elements = [...panel.querySelectorAll('button, input[type="radio"]:checked')].filter(el => !el.disabled);
        const first = elements[0], last = elements[elements.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }
    });
    market.querySelector('form').addEventListener('submit', () => {
      market.querySelector('input[name="return_to"]').value = location.pathname + location.search + location.hash;
      panel.setAttribute('aria-busy', 'true');
      market.querySelector('button[type="submit"]').disabled = true;
    });
  });
  const dismissOutside = event => {
    document.querySelectorAll('[data-header-market][open]').forEach(market => {
      if (!market.contains(event.target)) market.open = false;
    });
  };
  document.addEventListener('click', dismissOutside);
  document.addEventListener('focusin', dismissOutside);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('market-panel-open'));
  compact.addEventListener('change', () => document.querySelectorAll('[data-header-market][open]').forEach(market => market.open = false));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-header-market]').forEach(market => {
      market.open = false;
      market.querySelector('.header-market-panel').removeAttribute('aria-busy');
      market.querySelector('button[type="submit"]').disabled = false;
    });
    document.body.classList.remove('market-panel-open');
  });
  initialize(document);
})();
